class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if (!event.target.closest('price-range')) {
        this.debouncedOnSubmit(event);
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    _swat.initializeActionButtons('body');
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? '.mobile-facets__close-button'
          : '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    document.dispatchEvent(new Event('reinitializePriceSlider'));
    document.dispatchEvent(new Event('reinitCustomDropdown'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    // The price inputs are always in the form, so an untouched price range used
    // to put `filter.v.price.gte=&filter.v.price.lte=` into the URL of every
    // sort-only request (cu-869fh1cm9). Empty values are dropped one by one
    // rather than with FormData.delete, which would also drop the filled
    // entries of a multi-value filter.
    const searchParams = new URLSearchParams();
    for (const [key, value] of new FormData(form).entries()) {
      if (value !== '') searchParams.append(key, value);
    }
    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    document.body.classList.remove('overflow-hidden-mobile');
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      event.target.closest('.js-filter')?.removeAttribute('open');
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();

    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.querySelector('.apply-price-range')?.addEventListener('click', (e) => this.form.onSubmitHandler(e));
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRangeSlider {
  constructor(container) {
    this.container = container;
    this.initialize();
  }

  initialize() {
    this.minInput = this.container.querySelector(`#${this.container.querySelector('[name="filter.v.price.gte"]').id}`);
    this.maxInput = this.container.querySelector(`#${this.container.querySelector('[name="filter.v.price.lte"]').id}`);

    if (!this.minInput || !this.maxInput) {
      return;
    }

    this.minValue = this.parseValue(this.minInput.dataset.min) || 0;
    this.maxValue = this.parseValue(this.maxInput.dataset.max) || 10800;

    this.createSliderElements();
    this.addEventListeners();
    this.updateTrack();
  }

  parseValue(value) {
    if (!value) return null;
    return parseFloat(value.replace(/,/g, ''));
  }

  formatValue(value) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  createSliderElements() {
    this.sliderContainer = document.createElement('div');
    this.sliderContainer.classList.add('price-range-slider');

    this.track = document.createElement('div');
    this.track.classList.add('range-slider-track');

    const initialMinValue = this.parseValue(this.minInput.value) || this.minValue;
    const initialMaxValue = this.parseValue(this.maxInput.value) || this.maxValue;

    this.minSlider = this.createSlider('range-slider-min', initialMinValue);
    this.maxSlider = this.createSlider('range-slider-max', initialMaxValue);

    this.sliderContainer.append(this.track, this.minSlider, this.maxSlider);

    const parentContainer = this.container.querySelector('.facet__price-range-slider-wr');
    if (!parentContainer) {
      return;
    }
    parentContainer.appendChild(this.sliderContainer);
  }

  createSlider(className, defaultValue) {
    const slider = document.createElement('input');
    Object.assign(slider, {
      type: 'range',
      min: this.minValue,
      max: this.maxValue,
      value: defaultValue,
      className: className,
    });
    return slider;
  }

  updateTrack = () => {
    if (!this.track || !this.minSlider || !this.maxSlider) return;
    const minPercent = ((this.minSlider.value - this.minValue) / (this.maxValue - this.minValue)) * 100;
    const maxPercent = ((this.maxSlider.value - this.minValue) / (this.maxValue - this.minValue)) * 100;
    this.track.style.left = `${minPercent}%`;
    this.track.style.width = `${maxPercent - minPercent}%`;
  };

  updateInputsFromSlider = () => {
    const minVal = parseInt(this.minSlider.value, 10);
    const maxVal = parseInt(this.maxSlider.value, 10);

    if (minVal > maxVal - 500) {
      this.minSlider.value = maxVal - 500;
    }

    this.minInput.value = this.formatValue(parseInt(this.minSlider.value));
    this.maxInput.value = this.formatValue(parseInt(this.maxSlider.value));
    this.updateTrack();
  };

  updateSlidersFromInputs = () => {
    const minVal = this.parseValue(this.minInput.value) || this.minValue;
    const maxVal = this.parseValue(this.maxInput.value) || this.maxValue;

    if (minVal < this.minValue) {
      this.minInput.value = this.formatValue(this.minValue);
    }
    if (maxVal > this.maxValue) {
      this.maxInput.value = this.formatValue(this.maxValue);
    }
    if (minVal > maxVal - 500) {
      this.minInput.value = this.formatValue(maxVal - 500);
    }

    this.minSlider.value = this.parseValue(this.minInput.value);
    this.maxSlider.value = this.parseValue(this.maxInput.value);
    this.updateTrack();
  };

  addEventListeners() {
    this.minSlider.addEventListener('input', this.updateInputsFromSlider);
    this.maxSlider.addEventListener('input', this.updateInputsFromSlider);
    this.minInput.addEventListener('input', this.updateSlidersFromInputs);
    this.maxInput.addEventListener('input', this.updateSlidersFromInputs);
  }

  destroy() {
    if (this.sliderContainer) {
      this.sliderContainer.remove();
    }
    if (this.minSlider) {
      this.minSlider.removeEventListener('input', this.updateInputsFromSlider);
    }
    if (this.maxSlider) {
      this.maxSlider.removeEventListener('input', this.updateInputsFromSlider);
    }
    if (this.minInput) {
      this.minInput.removeEventListener('input', this.updateSlidersFromInputs);
    }
    if (this.maxInput) {
      this.maxInput.removeEventListener('input', this.updateSlidersFromInputs);
    }
  }

  reinitialize() {
    this.destroy();
    this.initialize();
  }
}

function initializePriceRangeSliders() {
  if (window.priceRangeSliders) {
    window.priceRangeSliders.forEach((slider) => slider.destroy());
  }
  window.priceRangeSliders = [];

  const priceContainers = document.querySelectorAll('.facets__price');

  priceContainers.forEach((container, index) => {
    const slider = new PriceRangeSlider(container);
    window.priceRangeSliders.push(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializePriceRangeSliders();
});

document.addEventListener('reinitializePriceSlider', () => {
  initializePriceRangeSliders();
});

class CustomDropdown {
  constructor(selectElement) {
    this.select = selectElement;
    this.form = this.select.closest('form');
    this.options = Array.from(this.select.options);
    this.init();
    this.setupReinitListener();
  }

  init() {
    this.createElements();
    this.setupEventListeners();
    this.renderOptions();
    this.updateSelected();
  }

  createElements() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('custom-dropdown-wrapper');

    this.dropdown = document.createElement('div');
    this.dropdown.classList.add('custom-dropdown');

    this.selectedDisplay = document.createElement('div');
    this.selectedDisplay.classList.add('custom-dropdown__selected');

    this.optionsContainer = document.createElement('div');
    this.optionsContainer.classList.add('custom-dropdown__options');

    this.dropdown.appendChild(this.selectedDisplay);
    this.dropdown.appendChild(this.optionsContainer);
    this.wrapper.appendChild(this.dropdown);

    this.select.parentNode.insertBefore(this.wrapper, this.select.nextSibling);
  }

  renderOptions() {
    this.options.forEach((option, index) => {
      const customOption = document.createElement('div');
      customOption.classList.add('custom-dropdown__option');

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      customOption.appendChild(checkbox);

      const box = document.createElement('span');
      box.classList.add('custom-dropdown__checkbox');
      customOption.appendChild(box);

      const label = document.createElement('span');
      label.textContent = option.text;
      customOption.appendChild(label);

      if (option.value === '') {
        customOption.classList.add('disabled');
        checkbox.disabled = true;
      }

      if (option.selected) {
        customOption.classList.add('selected');
        checkbox.checked = true;
      }

      if (option.value !== '') {
        customOption.addEventListener('click', (e) => {
          e.stopPropagation();

          this.select.value = option.value;

          this.options.forEach((opt) => {
            opt.selected = opt.value === option.value;
          });

          const changeEvent = new Event('change', { bubbles: true });
          this.select.dispatchEvent(changeEvent);

          this.updateSelectedDisplay(option.text);
          this.optionsContainer.querySelectorAll('.custom-dropdown__option').forEach((opt) => {
            opt.classList.remove('selected');
            opt.querySelector('input[type="checkbox"]').checked = false;
          });
          customOption.classList.add('selected');
          checkbox.checked = true;
          this.optionsContainer.classList.remove('open');

          if (this.form) {
            this.form.submit();
          }
        });
      }

      this.optionsContainer.appendChild(customOption);
    });
  }

  updateSelected() {
    const selectedOption = this.options.find((opt) => opt.selected) || this.options[0];
    this.selectedDisplay.textContent = selectedOption.text;
  }

  updateSelectedDisplay(text) {
    this.selectedDisplay.textContent = text;
  }

  setupEventListeners() {
    this.selectedDisplay.addEventListener('click', (e) => {
      e.stopPropagation();
      this.optionsContainer.classList.toggle('open');
    });

    document.addEventListener('click', () => {
      this.optionsContainer.classList.remove('open');
    });

    this.select.addEventListener('change', () => {
      const selectedOption = this.options.find((opt) => opt.value === this.select.value);
      if (selectedOption) {
        this.updateSelectedDisplay(selectedOption.text);
        this.optionsContainer.querySelectorAll('.custom-dropdown__option').forEach((opt) => {
          opt.classList.remove('selected');
          opt.querySelector('input[type="checkbox"]').checked = false;
        });
        const customOption = Array.from(this.optionsContainer.children).find(
          (opt) => opt.querySelector('span').textContent === selectedOption.text
        );
        if (customOption) {
          customOption.classList.add('selected');
          customOption.querySelector('input[type="checkbox"]').checked = true;
        }
      }
    });
  }

  setupReinitListener() {
    document.addEventListener('reinitCustomDropdown', () => {
      const id = this.select.id;
      this.destroy();
      this.select = document.querySelector(`#${id}`);
      if (this.select) {
        this.form = this.select.closest('form');
        this.options = Array.from(this.select.options);
        this.init();
      }
    });
  }

  destroy() {
    if (this.wrapper) {
      this.wrapper.remove();
    }
    this.wrapper = null;
    this.dropdown = null;
    this.selectedDisplay = null;
    this.optionsContainer = null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('#SortBy');
  const selectMobile = document.querySelector('#SortBy-mobile');
  if (select) {
    new CustomDropdown(select);
  }
  if (selectMobile) {
    new CustomDropdown(selectMobile);
  }
});
